document.addEventListener('DOMContentLoaded', () => {
    const addCheckboxListener = (key) => {
        const checkbox = document.querySelector(`.gift-wrapping-checkbox[data-line-key="${key}"]`);
        if (!checkbox) return;
        
        checkbox.addEventListener('change', async () => {
            const lineKey = checkbox.getAttribute('data-line-key');
            const giftWrappingProduct = checkbox.getAttribute('data-gift-id');
            const giftWrappingQuantity = 1;

            if (checkbox.checked) {
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: giftWrappingProduct,
                        quantity: giftWrappingQuantity
                    })
                })
                    .then(() => {
                        fetch(window.Shopify.routes.root + 'cart/change.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                "id": lineKey,
                                "properties": { "_giftwrap": true }
                            })
                        })
                            .then(() => {
                                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
                            });
                    });
            } else {
                // Fetch the current cart to check for the gift wrapping product
                await fetch('/cart.js')
                    .then(response => response.json())
                    .then(cart => {
                        const giftWrapItem = cart.items.find(item => item.id == giftWrappingProduct);
                        if (giftWrapItem) {
                            const newQuantity = parseInt(giftWrapItem.quantity) - 1;
                            return fetch('/cart/change.js', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    id: giftWrapItem.key,
                                    quantity: newQuantity > 0 ? newQuantity : 0
                                })
                            });
                        }
                    })
                    .then(() => {
                        fetch(window.Shopify.routes.root + 'cart/change.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                "id": lineKey,
                                "properties": { "_giftwrap": false }
                            })
                        })
                            .then(() => {
                                document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
                            });
                    });
            }
        });
    };

    // Initial call to add the listener
    setTimeout(() => {
        const lineItems = document.querySelectorAll('line-item');
        lineItems.forEach(lineItem => {
            addCheckboxListener(lineItem.dataset.key);
        });
    }, 500)

    // If cart:refresh event is fired, re-add the listener after 500ms
    document.documentElement.addEventListener('cart:refresh', () => {
        setTimeout(() => {
            const lineItems = document.querySelectorAll('line-item');
            lineItems.forEach(lineItem => {
                addCheckboxListener(lineItem.dataset.key);
            });
        }, 500);
    });
    // If variant:add event is fired, re-add the listener after 500ms
    document.addEventListener('variant:add', function(event) {
        setTimeout(() => {
            const lineItems = document.querySelectorAll('line-item');
            lineItems.forEach(lineItem => {
                addCheckboxListener(lineItem.dataset.key);
            });
        }, 500);
    });});
